import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Fallback für Entwicklung ohne Supabase
const isDevelopment = !supabaseUrl || !supabaseAnonKey

if (isDevelopment) {
  console.warn('⚠️  Supabase nicht konfiguriert - verwende Mock-Daten für Entwicklung')
  console.warn('📝 Erstellen Sie eine .env Datei mit:')
  console.warn('   VITE_SUPABASE_URL=https://your-project.supabase.co')
  console.warn('   VITE_SUPABASE_ANON_KEY=your-anon-key')
}

// Dummy-Client für Entwicklung
const dummyUrl = 'https://dummy.supabase.co'
const dummyKey = 'dummy-key'

export const supabase = createClient(
  supabaseUrl || dummyUrl,
  supabaseAnonKey || dummyKey,
  {
    auth: {
      persistSession: true,        // Session in localStorage speichern
      autoRefreshToken: true,      // Token automatisch erneuern
      detectSessionInUrl: false    // Kein OAuth-Redirect nötig
    }
  }
)

// Export für Hook-Verwendung
export const isSupabaseConfigured = !isDevelopment

// Debug-Ausgabe
console.log('🚀 Supabase Status:', isSupabaseConfigured ? '✅ Konfiguriert' : '⚠️  Mock-Modus') 